<template>
  <div class="roomGeneralViewManagement clearfix">
    <el-row>
      <span class="label" style="padding-left: 15px;">楼栋号:</span>
      <el-select v-model="buildingId" placeholder="请选择" class="small" @change="selectBuild">
        <el-option v-for="item in buildList" :key="item.buildingId" :label="item.buildingName"
          :value="item.buildingId"></el-option>
      </el-select>
      <span class="label">楼层号:</span>
      <el-select v-model="floorNum" placeholder="请选择" class="small" @change="selectFloor">
        <el-option v-for="item in floorList" :key="item.floor" :label="item.floorName" :value="item.floor"></el-option>
      </el-select>
      <span class="label">房间号:</span>
      <el-select v-model="roomId" placeholder="请选择" class="small" clearable @change="selectRoom">
        <el-option v-for="item in roomList" :key="item.roomId" :label="item.roomNo" :value="item.roomId"></el-option>
      </el-select>
    </el-row>
    <div class="roomItem" v-for="(item, index) in bedList" :key="index">
      <!-- by guo 2020-3-13-10:48修改 -->
      <div class="roomItem-room">
        <span style="font-size:16px;text-align:center">{{ item.location }}</span>
        <!-- <span style="font-size:13px;float: right;">{{item.oldmanName}}</span> -->
      </div>
      <!-- <div class="roomItem-div" :class="{'roomItem-div-active':item.alarmFlag==true}" style="background:#ffffff" @click="handleRoomItem(item,index)"> -->
      <div class="roomItem-div" @click="handleBedItem(item)">
        <div class="roomItem-div-img">
          <el-carousel :interval="5000" trigger="click" :autoplay="true" :ref="'carousel' + index"
            indicator-position="none" arrow="never">
            <el-carousel-item v-for="(temp, index2) in item.img" :key="index2" :style="{ background: temp.background }"
              class="carousel-item-active">
              <img v-if="temp.alert == 1" :src="temp.images" alt=""
                style="height:90%;margin:0 auto; padding-top:6px;max-width: 120px;object-fit: scale-down;">
              <img v-else :src="temp.images" alt=""
                style="height:60%;margin:0 auto; padding-top:2px;max-width: 100px;object-fit: scale-down;">
              <!-- by guo 2020-3-16-13:24修改  需求变更 去掉温度的显示  修改为对应报警的文字 -->
              <div class="roomItem-div-text"
                style="margin:0 auto; overflow:hidden;align-items: center;font-size:20px;display: flex;justify-content: center;"
                :title="temp.alarmMsg">
                <p v-html="temp.alarmMsg"></p>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- by guo 2020-3-16-13:24修改  需求变更 去掉温度的显示  修改为对应报警的文字 -->
        <!-- <div class="roomItem-div-text" v-if="item.temperature!=null"><span>{{roomGeneralViewManagement.roomTemperature}}:</span><span>{{item.temperature}}</span><span>℃</span></div> -->
        <div class="roomItem-div-text">
          <span style="font-weight:300">{{ item.oldmanName }}</span>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import offLine from '@/assets/device/gatewayOff.png';//设备离线
import xindian from '@/assets/device/xinlv_err.png'; //心率1异常
import statusinbed from '@/assets/device/life_status_inbed.png';//在床
import statusoutbed from '@/assets/device/life_status_outbed.png';//离床
import diviceNot from '@/assets/device/diviceNot.png';//没有设备
import inRoom from '@/assets/device/radar/in.png';//in
import outRoom from '@/assets/device/radar/out.png';//out

export default {
  name: "BedDeviceManager",//BedDeviceManager
  data() {
    return {
      size: "medium",//按钮的尺寸
      isActive: 0,//默认第一个被选中  通过点击来切换  被点击的就给一个被选中的样式
      buildList: [],//查询所有的楼栋
      currentBuild: {},
      bedList: [],
      ids: [],
      timeSpace : 30,
      buildingId: "",
      floorList: [],
      roomId: '',
      floorNum: null,
      roomList: [],
      actionrun: null,
      timeOne: null,
      timeTwo: null,
      roomDeviceList:[],
      deviceNoList:[],
    };
  },
  methods: {
    /* 
      选择不同的楼栋 
    */
    selectBuild(val) {
      this.buildingId = val;
      this.floorList = [];
      this.floorNum = 1;
      this.buildList.forEach(build => {
        if (build.buildingId == val) {
          this.floorList = [];
          for (let i = 1; i <= build.floorNum; i++) {
            this.floorList.push({
              floor: i,
              floorName: i + '层'
            })
          }
        }
      })
      this.getRoomList(this.buildingId, this.floorNum);
    },
    selectFloor(val) {
      this.floorNum = val;
      this.getRoomList(this.buildingId, this.floorNum);
      this.getDeviceListByBuild();
    },
    selectRoom(val) {
      console.log(val);
      this.roomId = val;
      this.getDeviceListByBuild();
    },
    /*  
      点击房间跳转到房间详情
    */
    handleBedItem(item) {
      // 
      if(item.deviceType == 30){
        bus.$emit("homePage", {
          type: "jump",
          path: "/FallRadarDetail",
          title: '雷达数据',
          params: {
            deviceNo: item.deviceNo
          }
        });
      }else{
        bus.$emit("homePage", {
        type: "jump",
        path: "/RadarDetail",
        title: '雷达数据',
        params: {
          deviceNo: item.deviceNo
        }
      });
      }
      
    },

    /* 
      获取所有的楼栋 显示的第一条数据
    */
    showDefaultBuild() {
      this.$postForm("omc/Building/showAll", {}).then(res => {
        if (res.result != null) {
          this.buildList = res.result;
          for (var i = 0; i < res.result.length; i++) {
            if (i == 0) {
              this.buildingId = res.result[0].buildingId
              this.currentBuild = res.result[0];
              this.floorList = [];
              // floorNum
              for (let i = 1; i <= res.result[0].floorNum; i++) {
                this.floorList.push({
                  floor: i,
                  floorName: i + '层'
                })
              }
              break;
            }
          }
        }
        this.floorNum = null;
        this.getRoomList(this.buildingId, null);
      });
    },
    /**
     * 根据bed获取设备
     */
    getDeviceListByBuild() {
      console.log(this.buildingId);
      console.log(this.floorNum);
      console.log(this.roomId);
      let param = {
        buildingId: this.buildingId,
        floorNo: this.floorNum,
        roomId: this.roomId
      };
      console.log(param);
      this.$postJson("omc/Bed/selectBedInfor", param).then(res => {
        let roomIdList = [];
        let bedIdList = [];
        res.result.forEach(item => {
          roomIdList.push(item.roomId);
          bedIdList.push(item.bedId);
        })
        roomIdList = Array.from(new Set(roomIdList))
        bedIdList = Array.from(new Set(bedIdList))
        console.log(roomIdList);
        console.log(bedIdList);
        this.roomIdList = roomIdList;
        this.bedIdList = bedIdList;
        this.getDeviceNoList();
      });
    },
    getDeviceNoList(){
      let params = {
        bedIdList: this.bedIdList,
        roomIdList: this.roomIdList
      }
      this.$postJson("dmc/commonDevice/queryDeviceDataListByBedIdList", params).then(res => {
        this.mergeData(res.result);
      })
    },
    mergeData(datalist) {
      let bedDeviceList = datalist;
      console.log(datalist);
      let bedList = [];
      for (let i = 0; i < bedDeviceList.length; i++) {
        if (bedDeviceList[i].deviceNo != null) {
          bedDeviceList[i].img = new Array();
          //没有设备
          if (bedDeviceList[i].offLine == null) {
            bedDeviceList[i].img.push({ 'images': diviceNot, 'alarmMsg': "暂无设备", isbgFlag: true, 'background': "#ffffff" });
            bedDeviceList[i].background = "#ffffff";
            continue;
          } else {
            if (bedDeviceList[i].offLine == 1) { //离线
              bedDeviceList[i].img.push({ 'images': offLine, 'alarmMsg': "设备调试中", isbgFlag: true, 'background': "#ffffff" });
              bedDeviceList[i].background = "#ffffff";
            } else if (bedDeviceList[i].inBed == 1) { //在床
              //跌倒雷达
              if (bedDeviceList[i].deviceType == 30) {
                if (bedDeviceList[i].action == 1) {
                  bedDeviceList[i].img.push({ 'images': xindian, 'alarmMsg': "老人跌倒", isbgFlag: true, 'background': "#ffffff" });
                  bedDeviceList[i].background = "#00ff00";
                }else{
                  let msg = "有人";
                  bedDeviceList[i].img.push({ 'images': inRoom, 'alarmMsg': msg, isbgFlag: true, 'background': "#ffffff" });
                  bedDeviceList[i].background = "#ffffff";
                }
              }else{
                let msg = "心率" + bedDeviceList[i].heart + "   呼吸" + bedDeviceList[i].breath;
                bedDeviceList[i].img.push({ 'images': statusinbed, 'alarmMsg': msg, isbgFlag: true, 'background': "#ffffff" });
                bedDeviceList[i].background = "#ffffff";
                if (bedDeviceList[i].heart > 130 || bedDeviceList[i].heart < 45) {
                  bedDeviceList[i].img.push({ 'images': xindian, 'alarmMsg': "心率异常", isbgFlag: true, 'background': "#ffffff" });
                  bedDeviceList[i].background = "#00ff00";
                }
                if (bedDeviceList[i].breath > 38 || bedDeviceList[i].breath < 5) {
                  bedDeviceList[i].img.push({ 'images': xindian, 'alarmMsg': "呼吸异常", isbgFlag: true, 'background': "#ffffff" });
                  bedDeviceList[i].background = "#00ff00";
                }
              }
            } else { //离床
              let msg = "老人离床";
              if (bedDeviceList[i].deviceNo.indexOf("RVD")!=-1) {
                msg = "无人";
                bedDeviceList[i].img.push({ 'images': outRoom, 'alarmMsg': msg, isbgFlag: true, 'background': "#ffffff" });
              }else{
                bedDeviceList[i].img.push({ 'images': statusoutbed, 'alarmMsg': msg, isbgFlag: true, 'background': "#ffffff" });
              }
              bedDeviceList[i].background = "#ffffff";
            }
          }
          bedList.push(bedDeviceList[i]);
        }
      }
      this.bedList = bedList;
    },
    /** 
      获取房间列表
    */
    getRoomList(buildingId, floorNo) {
      let params = new Object();
      params.buildingId = buildingId;
      params.floorNo = floorNo;
      this.$postJson("omc/Room/queryRoomInfo", params).then(res => {
        this.roomList = res.result;//展示床位列表
      })
      this.getDeviceListByBuild();
    },

    /*
    * by guo 2020-3-19-9:11
    * JSON数组去重
    * @param: [array] json Array
    * @param: [string] 唯一的key名，根据此键名进行去重
    */
    uniqueArray(array, key) {
      var result = [array[0]];
      for (var i = 1; i < array.length; i++) {
        var item = array[i];
        var repeat = false;
        for (var j = 0; j < result.length; j++) {
          if (item[key] == result[j][key]) {
            repeat = true;
            break;
          }
        }
        if (!repeat) {
          result.push(item);
        }
      }
      return result;
    },
  },
  created() {
    //每过2min刷新一次?
    this.timeOne = setInterval(() => {
      this.getDeviceNoList();
    }, this.timeSpace * 1000);
    this.showDefaultBuild();
  },
  activated() {
  },
  mounted() {
  },
  destroyed() {
    clearInterval(this.timeOne);
  },
};
</script>
<style lang="scss" scoped>
  .roomGeneralViewManagement{
    .toolbar{
      margin: 0px 0px !important;
    }
    .formItemButton{
      border:1px solid #8d8d8d;
      color:#8d8d8d;
    }
    .buttonActive{
      background: #3a77e2;
      color:#fefefe;
    }
    //by guo 2020-3-16-16:31添加
    .roomItem-div-text{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-weight: 600 !important;
    }
    .label{
      padding-left: 30px;
      padding-right: 5px;
    }
    @media (max-width: 1023px){ 
      .roomItem{
        float: left;
        width: 22%;
        height: 150px;
        margin:1.3%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          font-size: 16px;
          color:#666666;
        }
        .roomItem-div{
          height:120px;
          background: #ffffff;
          color:#343434;
          .roomItem-div-img{
            height: 80px;
            // line-height: 80px;
            img{
              vertical-align: middle;
            }  
          }
          .roomItem-div-text{
            height:50px;
            // line-height: 22px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 140px;
        }
        ::v-deep .el-carousel__container {
          height: 140px;
        }
      }
    }
    @media (min-width: 1024px){ 
      .roomItem{
        float: left;
        width: 16%;
        height: 150px;
        margin:1.3%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          font-size: 16px;
          color:#666666;
        }
        .roomItem-div{
          height:120px;
          background: #ffffff;
          color:#343434;
          .roomItem-div-img{
            height: 80px;
            // line-height: 80px;
            img{
              vertical-align: middle;
            }  
          }
          .roomItem-div-text{
            height:50px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 120px;
        }
        ::v-deep .el-carousel__container {
          height: 120px;
        }
      }
    }
    @media (min-width: 1100px) {
      .roomItem{
        float: left;
        width: 14%;
        height: 150px;
        margin:1.3%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          font-size: 16px;
          color:#666666;
        }
        .roomItem-div{
          height:120px;
          background: #ffffff;
          color:#343434;
          .roomItem-div-img{
            height: 80px;
            // line-height: 80px;
            img{
              vertical-align: middle;
            } 
          }
          .roomItem-div-text{
            height:50px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 140px;
        }
        ::v-deep .el-carousel__container {
          height: 140px;
        }
      }
    } 
    @media (min-width: 1366px) {
      .roomItem{
        float: left;
        width: 12%;
        height: 160px;
        margin:1%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          font-size: 16px;
          color:#666666;
        }
        .roomItem-div{
          height:140px;
          background: #ffffff;
          color:#343434;
          .roomItem-div-img{
            height: 70px;
            // line-height: 70px;
            img{
              vertical-align: middle;
            } 
          }
          .roomItem-div-text{
            height:50px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 140px;
        }
        ::v-deep .el-carousel__container {
          height: 140px;
        }
      }
    }  
    @media (min-width: 1440px) {
       .roomItem{
        float: left;
        width: 12%;
        height: 160px;
        margin:1%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          font-size: 16px;
          color:#666666;
        }
        .roomItem-div{
          height:120px;
          background: #ffffff;
          color:#343434;
          .roomItem-div-img{
            height: 80px;
            // line-height: 80px;
            img{
              vertical-align: middle;
            } 
          }
          .roomItem-div-text{
            height:50px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4 !important;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 120px;
        }
        ::v-deep .el-carousel__container {
          height: 120px;
        }
      }
    }
    @media (min-width: 1680px) {
       .roomItem{
        float: left;
        width: 9%;
        height: 160px;
        margin:0.72%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          font-size: 16px;
          color:#666666;
        }
        .roomItem-div{
          height:120px;
          background: #ffffff;
          color:#343434;
          .roomItem-div-img{
            height: 110px;
            // line-height: 110px;
            img{
              vertical-align: middle;
            } 
          }
          .roomItem-div-text{
            height:50px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 120px;
        }
        ::v-deep .el-carousel__container {
          height: 120px;
        }
      }
    } 
    @media (min-width: 1920px) {
       .roomItem{
        float: left;
        width: 7%;
        height: 170px;
        margin:0.72%;
        border:1px solid #ccc;
        text-align: center;
        .roomItem-room{
          height:20px;
          color:#666666;
          font-size: 16px;
        }
        .roomItem-div{
          height:130px;
          background: #ffffff;
          color: #343434;
          .roomItem-div-img{
            height: 110px;
            // line-height: 110px;
            img{
              vertical-align: middle;
            } 
          }
          .roomItem-div-text{
            height:50px;
            font-size: 14px;
            font-weight: 500;
          }
        }
        .roomItem-div-active{
          background: #3a77e2;
          z-index: 9999;
        }
        .roomItem-div:hover{
          background: #bee1f4;
          cursor: pointer;
        }
        //by guo 2020-3-23-9:15添加
        .carousel-item-active{
          background:#fff;
          height: 130px;
        }
        ::v-deep .el-carousel__container {
          height: 130px;
        }
      }
    } 
  }
   //by guo 2020-3-28-15:55修改 注释
  // ::v-deep .roomItem-div .el-carousel__container {
  //   height: 140px;
  // }
  ::v-deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view{
    white-space: nowrap;
    width:100%;
    height:100%;
    overflow-x: auto;
  }
  ::v-deep .el-form--inline{
    position: relative;
    z-index: 99;
  }
  .filtersposition{
    position: absolute;
    top:-10px;
    left:0;
    right:0;
    bottom:10px;
    width:100%;
    max-height:56px;
    background: #F2F2F2;
    z-index:1;
  }
  //by guo 2020-3-28-15:55修改  去掉屏幕缩放时的房间一览小块的y轴滚动条
  ::v-deep .roomItem-div .el-carousel--horizontal{
    overflow-y: hidden;
  }
</style>